import React from "react";
import { Box, CardContent } from "@mui/material";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { actions } from "../registrationActions";
import { t } from "i18next";

const RegistrationResponse = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleGoBack = () => {
    dispatch(actions.resetRegistrationLoading());
    navigate("/login");
  };

  return (
    <CardContent className="py-8 px-24">
      <h2 className="font-bold text-2xl mb-12 w-full mx-auto text-center text-primary">
        {t("YourAccountCreated")}
      </h2>
      <Box className="flex w-full mx-auto mt-16 mb-2 space-x-2">
        <CoreButton
          className="btn-round-outline w-1/2 text-primary border-primary mx-auto"
          testo={t("BackToLogin")}
          onClick={handleGoBack}
        />
      </Box>
    </CardContent>
  );
};

export default RegistrationResponse;
